/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../common';
import '../../../addons/shared/first_party_addons';
import '../../../sub2/data';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "precog": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "signals": {
                    "nested": {
                      "SignalType": {
                        "values": {
                          "SIGNAL_UNKNOWN": 0,
                          "SIGNAL_PRODUCT_INTENT": 1,
                          "SIGNAL_BEST_AVAILABLE_PRODUCT_INTENT": 2,
                          "SIGNAL_PERSONA": 3,
                          "SIGNAL_ADDON_SELF_SELECTED": 4,
                          "SIGNAL_PRODUCT_ADOPTION": 5,
                          "SIGNAL_APPOINTMENTS_FEATURE": 6,
                          "SIGNAL_APPOINTMENTS_SUGGESTED_SUBSCRIPTION": 7,
                          "SIGNAL_SUBAUDIENCE": 8
                        }
                      },
                      "FetchResponse": {
                        "fields": {
                          "productIntents": {
                            "type": "squareup.precog.api.v2.Product",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "bestAvailableProductIntent": {
                            "type": "squareup.precog.api.v2.Product",
                            "id": 2,
                            "rule": "optional"
                          },
                          "persona": {
                            "type": "squareup.precog.api.v2.signals.Persona",
                            "id": 3,
                            "rule": "optional"
                          },
                          "addonSelfSelected": {
                            "type": "squareup.addons.shared.FirstPartyAddon",
                            "id": 4,
                            "rule": "optional"
                          },
                          "addonsSelfSelected": {
                            "type": "squareup.addons.shared.FirstPartyAddon",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "productAdoptions": {
                            "type": "squareup.precog.api.v2.Product",
                            "id": 6,
                            "rule": "repeated"
                          },
                          "appointmentsFeatures": {
                            "type": "squareup.precog.api.v2.signals.AppointmentsFeature",
                            "id": 7,
                            "rule": "repeated"
                          },
                          "appointmentsSuggestedSubscription": {
                            "type": "squareup.sub2.data.Feature",
                            "id": 8,
                            "rule": "optional"
                          },
                          "subaudience": {
                            "type": "squareup.precog.api.v2.Subaudience",
                            "id": 9,
                            "rule": "optional"
                          }
                        }
                      },
                      "Persona": {
                        "values": {
                          "PERSONA_UNKNOWN": 0,
                          "PERSONA_BASIC": 1,
                          "PERSONA_FAST_SERVICE": 2,
                          "PERSONA_CUSTOMER_EXPERIENCE": 3
                        }
                      },
                      "AppointmentsFeature": {
                        "values": {
                          "APPOINTMENTS_FEATURE_UNKNOWN": 0,
                          "APPOINTMENTS_FEATURE_COMMISSION_TRACKING": 1,
                          "APPOINTMENTS_FEATURE_MULTISTAFF_APPOINTMENTS": 2,
                          "APPOINTMENTS_FEATURE_RESOURCE_MANAGEMENT": 3,
                          "APPOINTMENTS_FEATURE_PROCESSING_TIME": 4
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.precog?.nested?.api?.nested?.v2?.nested?.signals?.nested?.SignalType && !$root.nested?.squareup?.nested?.precog?.nested?.api?.nested?.v2?.nested?.signals?.nested?.FetchResponse && !$root.nested?.squareup?.nested?.precog?.nested?.api?.nested?.v2?.nested?.signals?.nested?.Persona && !$root.nested?.squareup?.nested?.precog?.nested?.api?.nested?.v2?.nested?.signals?.nested?.AppointmentsFeature) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SignalType @ squareup/precog/v2/signals/common.proto at 14:1
 */
export const SignalType = $root.lookupEnum('squareup.precog.api.v2.signals.SignalType').values;
/**
 * SOURCE FetchResponse @ squareup/precog/v2/signals/common.proto at 26:1
 */
export const FetchResponse = $root.lookupType('squareup.precog.api.v2.signals.FetchResponse');
fixType(FetchResponse);
Builder.createAndAttachToType(FetchResponse);
/**
 * SPOS Persona (see go/spospersonas).
 *
 * SOURCE Persona @ squareup/precog/v2/signals/common.proto at 54:1
 */
export const Persona = $root.lookupEnum('squareup.precog.api.v2.signals.Persona').values;
/**
 * Appointments features suggested during onboarding flow
 * See: https://docs.google.com/document/d/1SuyLJzNB8t1bb84wVvR86c8AjeRH-fvKwemHGBhbwQY/edit#heading=h.rtfjahsnvkpf
 *
 * SOURCE AppointmentsFeature @ squareup/precog/v2/signals/common.proto at 63:1
 */
export const AppointmentsFeature = $root.lookupEnum('squareup.precog.api.v2.signals.AppointmentsFeature').values;